import { DateRange } from "react-day-picker";
import { create } from "zustand";
import storage, { ObjectKeys, StringKeys } from "@/utils/storage";
import { SelectedRange, TableFilter } from "@/types/utils";
import constant from "@/utils/constant";

// TODO: Use Zustand's persist middleware to persist the state across sessions

interface InitialState {
  date: DateRange;
  selectedRange: SelectedRange;
}

interface Actions {
  setDate: (
    date: DateRange,
    type: StringKeys | ObjectKeys,
    selectedRange?: SelectedRange
  ) => void;
  reset: () => void;
}

const today = new Date();
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
firstDayOfMonth.setHours(0, 0, 0, 0);

const initialState: InitialState = {
  date: {
    from: firstDayOfMonth,
    to: today,
  },
  selectedRange: "thisMonth",
};

export const useCalendarContext = create<InitialState & Actions>((set) => ({
  ...initialState,
  setDate: (
    date: DateRange,
    key: StringKeys | ObjectKeys,
    selectedRange?: SelectedRange
  ) =>
    set(() => {
      const value = date ?? { from: undefined, to: undefined };
      const existingFilter = storage.getItem(key as ObjectKeys) as TableFilter;

      if (constant.filterStorageObjectKeys.includes(key as typeof constant.filterStorageObjectKeys[number])) {
        const updatedFilter = {
          ...existingFilter,
          dates: value,
        };
        if (selectedRange !== undefined) {
          updatedFilter.selectedRange = selectedRange;
        } else {
          delete updatedFilter.selectedRange;
        }
        storage.setItem(key as ObjectKeys, updatedFilter);
      } else {
        const toStore: { from: Date | undefined; to?: Date | undefined; selectedRange?: SelectedRange } = {
          ...value,
        };
        if (selectedRange !== undefined) {
          toStore.selectedRange = selectedRange;
        } else {
          delete toStore.selectedRange;
        }
        storage.setItem(key as StringKeys, JSON.stringify(toStore));
      }
      return { date: value, selectedRange: selectedRange ?? "custom" };
    }),
  reset: () =>
    set(() => {
      return { ...initialState };
    }),
}));
